import { Campaign } from '../models/Campaign';
import { CampaignService } from '../services/firebase';
import { geocodeAddress } from './geocoding';

export const updateCampaignLocations = async (campaigns: Campaign[]): Promise<void> => {
    for (const campaign of campaigns) {
        if (!campaign.id || !campaign.city) continue;
        
        // Skip if already has coordinates
        if (campaign.latitude && campaign.longitude) continue;

        // Get coordinates for the city
        const coordinates = await geocodeAddress(campaign.centre_name || '', campaign.city);
        
        if (coordinates) {
            try {
                await CampaignService.updateCampaignCoordinates(
                    campaign.id,
                    coordinates.lat,
                    coordinates.lng
                );
                console.log(`Updated coordinates for ${campaign.centre_name}`);
                
                // Add a small delay to avoid hitting API rate limits
                await new Promise(resolve => setTimeout(resolve, 200));
            } catch (error) {
                console.error(`Failed to update coordinates for ${campaign.centre_name}:`, error);
            }
        }
    }
}; 